<template>
  <section>
    <TableListing
      :items="items"
      :fields="fieldsAll"
      :showPaginationRow="true"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
    >
      <template v-slot:cell(lastChangedAt)="data">
        <span>{{ data.item.lastChangedAt | moment('MMM Do YY, h:mm a') }}</span>
      </template>
      <template v-slot:cell(quantityOld)="data">
        <span>{{ data.item.quantityOld }}</span>
      </template>
      <template v-slot:cell(quantityNew)="data">
        <span>{{ data.item.quantityNew }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'HistoricalInventoryReport-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: 'lastChangedAt',
        sortDesc: true,
        perPage: 20,
        page: 1
      },
      tableOptions: {
        totalRows: 20,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'clientName', label: 'Client', sortable: true },
        { key: 'item', label: 'Item', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
        { key: 'lastChangedAt', label: 'Last Changed At', sortable: true },
        //{ key: 'quantityOld', label: 'Qty Old', sortable: true },
        { key: 'quantityNew', label: 'Qty New', sortable: true },
        { key: 'inventoryChangeReason', label: 'Change Reason', sortable: true },
        { key: 'internalNote', label: 'Internal Note', sortable: true }
      ]
    }
  }
}
</script>

<style>

</style>
